<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('zqyq')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <div class="search">
                        <div class="searchleft">
                            <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                                <el-form-item :label="$t('gjz')">
                                    <el-input v-model="searchform.phone" @keyup.enter.native="onSubmit" size="small" :placeholder="$t('phone')">
                                    </el-input>
                                </el-form-item>
                                <!-- <el-form-item :label="$t('type')">
                                    <el-select size="small" v-model="searchform.type" style="width:180px;" :placeholder="$t('qxztype')"  >
                                        <el-option :label="$t('buxian')" :value="null"></el-option>
                                        <el-option :label="$t('zq')" :value="1"></el-option>
                                        <el-option :label="$t('yq')" :value="2"></el-option>
                                    </el-select>
                                </el-form-item> -->
                                <el-form-item :label="$t('time')">
                                    <el-date-picker
                                    v-model="value1"
                                    type="datetimerange"
                                    size="small"
                                    range-separator="至"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    start-placeholder="开始时间"
                                    end-placeholder="结束时间">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item>
                                    <el-button size="small" type="primary" @click="onSubmit">查询</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <el-table :data="list"
                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" stripe border style="width: 100%">
                        <el-table-column prop="phone" :label="$t('phone')"></el-table-column>
                        <el-table-column prop="orderNo" :label="$t('orderNo')"></el-table-column>
                        <el-table-column prop="feeMoney" :label="$t('amount')"></el-table-column>
                        <el-table-column prop="days" :label="$t('day')"></el-table-column>
                        <el-table-column prop="level" :label="$t('createTime')">
                            <template slot-scope="scope">
                                {{scope.row.createTime|changedate}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="sourceMoney" :label="$t('sourceMoney')"></el-table-column>
                        <!-- <el-table-column prop="type" :label="$t('type')">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.type==1" type="primary" size="mini">{{$t('zq')}}</el-tag>
                                <el-tag v-if="scope.row.type==2" type="primary" size="mini">{{$t('yq')}}</el-tag>
                            </template>
                        </el-table-column> -->
                        <el-table-column prop="typeName" :label="$t('type')"></el-table-column>
                    </el-table>
                    <div class="page">
                        <app-page :total="total" :current="pageNo" :pageSize="pageSize"
                            @handleCurrentChange="currentchange" @handleSizeChange="handchange"></app-page>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                searchform: {
                    phone: "",
                    iden: ""
                },
                loading: false,
                showadd: false,
                list: [],
                value1:[],
                searchform:{},
                total: 1,
                pageNo: 1,
                pageSize: 10,
                status: 1,
            }
        },
        created() {
            this.getList()
        },
        methods: {
            getList() {
                this.loading = true
                _api.get(apiurl.rollover, {
                    page: this.pageNo,
                    size: this.pageSize,
                    type: 1,
                    phone: this.searchform.phone,
                    nation:localStorage.getItem("nation"),
                    createTime: this.value1
                }).then(res => {
                    this.loading = false
                    this.list = res.data.list
                    this.total = res.data.total
                })
            },
            onSubmit() {
                this.pageNo = 1
                this.getList()
            },
            handchange(data) { //分页Size变化
                this.pageSize = data
                this.pageNo = 1
                this.getList()
            },
            currentchange(data) { //当前页变化
                this.pageNo = data
                this.getList()
            },
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>